<template>
	<div class="inner draw" @mousemove="beginPath($event)">

		<div class="wrap" style="position: relative;">
			<canvas id="canvas" class="fl" style="image-rendering: pixelated;" :width="screenWidth"
				:height="screenHeight" @mousedown="canvasDown($event)" @mouseup="canvasUp($event)"
				@mousemove="canvasMove($event)" @touchstart="canvasDown($event)" @touchend="canvasUp($event)"
				@touchmove="canvasMove($event)">
			</canvas>
			<!-- 			<canvas class="mycanvas" canvas-id="mycanvas" @touchstart="touchstart" @touchmove="touchmove"
				@touchend="touchend"></canvas> -->
			<div id="tip" style="float: left">
				<h4 class="tips">当前签名人 # {{userName}}</h4>
			</div>
			<div id="control" style="float: left">
				<div id="canvas-control">
					<button class="el-button btn-orange el-button--primary" @click="controlCanvas('clear')">
						清除
					</button>
					<button @click="getImage" class="el-button btn-orange el-button--primary"
						:style="{ backgroundColor: bgColor }">
						{{ isSubmitting ? '提交中...' : '提交' }}
					</button>
				</div>
			</div>
		</div>
	</div>

</template>

<style>
	@media screen and (max-width: 9000px) {

		#img-box,
		#canvas-drawImage h5,
		#canvas-brush {
			display: none;
		}

		#canvas-drawImage button {
			width: auto;
			position: absolute;
			flex: 1;
		}

		.wrap #tip {
			display: flex;
			flex-direction: row;
			text-align: center;
			position: absolute;
			top: 1%;
			left: 85%;
			transform: rotate(10deg);
			-ms-transform: rotate(90deg);
			/* IE 9 */
			-moz-transform: rotate(90deg);
			/* Firefox */
			-webkit-transform: rotate(90deg);
			/* Safari 和 Chrome */
			-o-transform: rotate(90deg);
		}

		.tips {
			font-size: 20px;
			display: flex;
			position: absolute;
		}

		.wrap #control {
			height: 0px;
			display: flex;
			flex-direction: row;
			text-align: center;
			position: absolute;
			bottom: 35%;
			left: -20%;
			transform: rotate(10deg);
			-ms-transform: rotate(90deg);
			/* IE 9 */
			-moz-transform: rotate(90deg);
			/* Firefox */
			-webkit-transform: rotate(90deg);
			/* Safari 和 Chrome */
			-o-transform: rotate(90deg);
			/* Opera */
		}
	}

	.wrap {
		border: 1px #585858 solid;
		overflow: hidden;
		margin: 0 auto;
	}

	.disabled {
		background-color: #a2a2a2;
		cursor: not-allowed;
		pointer-events: none;
		/* 禁止再次点击 */
	}

	#canvas-control button {
		width: 130px;
		height: 50px;
		font-size: 33px;
		border-radius: 10px;
	}

	#control div {
		margin-top: 0px;
		margin-bottom: 60px;
	}
</style>
<script>
	import request from '@/components/request'
	import vc from 'vue-cookie'
	export default {
		data() {
			return {
				userName: '张三',
				userId: '',
				billProjectId: '',
				context: {},
				imgUrl: [],
				canvasMoveUse: true,
				// 存储当前表面状态数组-上一步
				preDrawAry: [],
				// 存储当前表面状态数组-下一步
				nextDrawAry: [],
				// 中间数组
				middleAry: [],
				// 配置参数
				config: {
					lineWidth: 10,
					lineColor: '#000000',
					shadowBlur: 1
				},
				isEnd: false, // 是否结束签名
				screenWidth: null,
				screenHeight: null,
				ctx: '', //绘图图像
				points: [], //路径点集合 
				drawWidth: '',
				drawHeight: '',
				isSubmitting: false,
				bgColor: '#409eff',
				imageWidth: 570,
				imageHeight: 285,
			}
		},
		created() {
			this.screenWidth = screen.availWidth
			this.screenHeight = screen.availHeight * 0.81
			let url = window.location.href
			const queryParams = this.getQueryParams(url)
			this.userName = queryParams.userName
			this.userId = queryParams.userId
			this.billProjectId = queryParams.billProjectId

		},
		mounted() {
			const canvas = document.querySelector('#canvas')
			this.context = canvas.getContext('2d')
			this.context.imageSmoothingEnabled = false;
			this.context.imageSmoothingQuality = 'low';
			this.context.translate(0.5, 0.5);
			// this.context.fillRect(0, 0, this.screenWidth, this.screenHeight);
			this.context.stroke();
			this.initDraw()
			this.setCanvasStyle()
		},
		watch: {
			screenWidth(val) {
				this.screenWidth = val
			}
		},
		methods: {
			isPc() {
				const userAgentInfo = navigator.userAgent
				const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
				let flag = true
				for (let v = 0; v < Agents.length; v++) {
					if (userAgentInfo.indexOf(Agents[v]) > 0) {
						flag = false
						break
					}
				}
				return flag
			},
			removeImg(src) {
				this.imgUrl = this.imgUrl.filter(item => item !== src)
			},
			initDraw() {
				const preData = this.context.getImageData(0, 0, this.imageWidth, this.imageHeight)
				// 空绘图表面进栈
				this.middleAry.push(preData)
			},
			canvasMove(e) {
				if (this.canvasMoveUse) {
					console.log('canvasMove')
					const t = e.target
					let canvasX
					let canvasY
					if (this.isPc()) {
						canvasX = e.clientX - t.parentNode.offsetLeft
						canvasY = e.clientY - t.parentNode.offsetTop
					} else {
						canvasX = e.changedTouches[0].clientX - t.parentNode.offsetLeft
						canvasY = e.changedTouches[0].clientY - t.parentNode.offsetTop
					}
					this.context.lineTo(canvasX, canvasY)
					this.context.stroke()
				}
			},
			beginPath(e) {
				const canvas = document.querySelector('#canvas')
				if (e.target !== canvas) {
					console.log('beginPath')
					this.context.beginPath()
				}
			},
			// mouseup
			canvasUp(e) {
				console.log('canvasUp')
				const preData = this.context.getImageData(0, 0, this.imageWidth, this.imageHeight)
				if (!this.nextDrawAry.length) {
					// 当前绘图表面进栈
					this.middleAry.push(preData)
				} else {
					this.middleAry = []
					this.middleAry = this.middleAry.concat(this.preDrawAry)
					this.middleAry.push(preData)
					this.nextDrawAry = []
				}
				this.canvasMoveUse = false
				this.isEnd = true
			},
			// mousedown
			canvasDown(e) {
				console.log('canvasDown')
				this.canvasMoveUse = true
				// client是基于整个页面的坐标
				// offset是cavas距离顶部以及左边的距离
				const canvasX = e.clientX - e.target.parentNode.offsetLeft
				const canvasY = e.clientY - e.target.parentNode.offsetTop
				this.setCanvasStyle()
				// 清除子路径
				this.context.beginPath()
				this.context.moveTo(canvasX, canvasY)
				console.log('moveTo', canvasX, canvasY)
				// 当前绘图表面状态
				const preData = this.context.getImageData(0, 0, this.imageWidth, this.imageHeight)
				// 当前绘图表面进栈
				this.preDrawAry.push(preData)
				e.preventDefault()
			},
			//      // 设置颜色
			//      setColor(color) {
			//        this.config.lineColor = color
			//      },
			// 设置笔刷大小
			setBrush(type) {
				this.config.lineWidth = type
			},
			// 操作
			controlCanvas(action) {
				switch (action) {
					case 'clear':
						this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height)
						this.preDrawAry = []
						this.nextDrawAry = []
						this.middleAry = [this.middleAry[0]]
						this.isEnd = false
						break
				}
			},
			// 生成图片
			getImage() {
				if (!this.userId) {
					alert('用户Id为空，无法进行保存')
					return
				}
				if (!this.billProjectId) {
					alert('委托单Id为空，无法进行保存')
					return
				}
				if (!this.isEnd) {
					alert('请先完成签名')
					return
				}
				debugger;
				if (this.isSubmitting) {
					alert('正在提交中，请稍等。。。')
					return
				}
				this.isSubmitting = true
				this.bgColor = '#a2a2a2'
				const canvas = document.querySelector('#canvas')
				const src = canvas.toDataURL('image/png')
				let pic = src
				let that = this
				request.post('upload', {
					base64: pic,
					userId: that.userId,
					billProjectId: that.billProjectId
				}).then(res => {
					debugger;
					if (res.data.status === '20') {
						alert('绘制成功')
					} else {
						alert(res.data.errMsg)
					}
					this.isSubmitting = false
					this.bgColor = '#409eff'
				}).catch(function(err) {
					alert(err)
				})
			},
			showToast(message, type) {
				this.$refs.toast.show(message, type);
			},
			// 设置绘画配置
			setCanvasStyle() {
				this.context.lineWidth = this.config.lineWidth
				this.context.shadowBlur = this.config.shadowBlur
				this.context.lineColor = this.config.lineColor
			},
			getViewportSize() {
				return {
					width: window.innerWidth || document.documentElement.clientWidth || document.body
						.clientWidth,
					height: window.innerHeight || document.documentElement.clientHeight || document.body
						.clientHeight
				}
			},
			// 解析url参数
			getQueryParams(url) {
				// 创建一个新的URL对象
				const urlObj = new URL(url);
				// 使用URLSearchParams获取查询参数
				const params = new URLSearchParams(urlObj.search);
				// 将所有参数转换为一个对象
				const queryParams = {};
				for (const [key, value] of params) {
					queryParams[key] = value;
				}
				return queryParams;
			}
		}

	}
</script>


// WEBPACK FOOTER //
// src/pages/phonedraw.vue